import React from "react";
import BackgroundHome from "./PageBackgrounds/BackgroundHome.jsx";
import "./Headers.css";
import Boogers from "../../media/Boogers.JPG";

export default function HomeHeader() {
    return (
        <>
        <div className="Headers">
        <BackgroundHome />
        </div>
        </>
    );
}